// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"3607":"00f6ad54aa4bf79c3b70","8613":"3cb029b77ffdcd934e3a"}[chunkId] + ".css";
};